<template>
  <ObjectListTabs v-if="artist" class="artist-tabs">
    <template slot-scope="{}">
      <b-nav-item :to="{name: 'artist-about', params: {artistId: artist.id}}">About</b-nav-item>
      <b-nav-item :to="{name: 'artist-videos', params: {artistId: artist.id}}">Videos</b-nav-item>
      <b-nav-item :to="{name: 'artist-albums', params: {id: artist.id}}">Albums</b-nav-item>
      <b-nav-item :to="{name: 'artist-live-stream-list', params: {artistId: artist.id}}">Live Streams</b-nav-item>
      <b-nav-item :to="{name: 'artist-activity', params: {artistId: artist.id}}">Activity</b-nav-item>
      <b-nav-item :to="{name: 'artist-featured', params: {artistId: artist.id}}">Featured In</b-nav-item>
    </template>
    <template slot="cmd" v-if="!isCurrent && isLoggedIn" slot-scope="{}">
      <b-button variant="secondary" :to="{name: 'artist-send-message', params: {artistId: artist.id}}" size="sm">
        <font-awesome-icon icon="comment"/>
      </b-button>
      &nbsp;
      <Report :artist="artist" label="Report artist" ref="report" class="report-artist"></Report>
    </template>
    <template slot="mobileCmd" v-if="!isCurrent && isLoggedIn" slot-scope="{}">
      <b-nav-item :to="{name: 'artist-send-message', params: {artistId: artist.id}}">Message</b-nav-item>
      <b-nav-item :to="{name: 'artist-report', params: {artistId: artist.id}}">Report</b-nav-item>
    </template>
  </ObjectListTabs>
</template>

<style scoped lang="scss">
  @import '@/assets/custom.scss';
  @import '~bootstrap/scss/mixins/_breakpoints.scss';

  .report-artist {
    /deep/ svg {
      color: $steel;

      &:hover {
        color: white;
      }
    }
  }
</style>

<script>
import { mapGetters } from 'vuex'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

import ObjectListTabs from '@/components/widgets/ObjectListTabs'
import Report from '@/components/widgets/Report'

export default {
  name: 'ArtistProfileTabs',
  components: {
    FontAwesomeIcon,
    ObjectListTabs,
    Report
  },
  props: {
    artist: Object
  },
  computed: {
    currentArtist () {
      return this.$store.getters['artist/artist']
    },
    isCurrent () {
      let current = this.currentArtist
      return current && current.id === this.artist.id
    },
    ...mapGetters('auth', ['isLoggedIn'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/ArtistProfileTabs.vue